import "core-js/modules/es6.function.name";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "report",
      rawName: "v-report",
      value: _vm.isH5Type ? _vm.reportData.专属福利查看(_vm.posterParams) : _vm.reportData.专属福利领取(_vm.posterParams),
      expression: "isH5Type ?reportData.专属福利查看(posterParams):reportData.专属福利领取(posterParams)"
    }],
    staticClass: "item",
    on: {
      "click": _vm.click
    }
  }, [_c('BaseItem', {
    attrs: {
      "item": _vm.item,
      "trigger-default": false,
      "stopClick": true
    }
  }, [_vm.showVipIcon ? _c('Icon', {
    attrs: {
      "slot": "icon",
      "type": "vip"
    },
    slot: "icon"
  }) : _c('Icon', {
    attrs: {
      "slot": "icon",
      "type": "level",
      "level": _vm.item.tActState.iLevel || 1
    },
    slot: "icon"
  })], 1), _c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.item.sTitle))]), _c('div', {
    staticClass: "bottom"
  }, [_vm.isHot ? _c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("@/assets/hot.svg"),
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("@/assets/new.svg"),
      "alt": ""
    }
  }), _c('span', {
    staticClass: "sub"
  }, [_vm._v(_vm._s(_vm.isHot ? '火热抢' : '新上线'))]), _vm.isH5Type ? _c('span', {
    staticClass: "btn"
  }, [_vm._v(_vm._s(_vm.isGot ? '使用' : '领取'))]) : _vm.isMounted ? [_vm.isGot ? _c('span', {
    staticClass: "btn"
  }, [_vm._v("使用")]) : _vm.isSnatchOut ? _c('span', {
    staticClass: "btn disabled"
  }, [_vm._v("已抢完")]) : _vm.isEnd ? _c('span', {
    staticClass: "btn disabled"
  }, [_vm._v("已结束")]) : _c('span', {
    staticClass: "btn"
  }, [_vm._v("领取")])] : _vm._e()], 2), _vm.isUseInfoVisible ? _c('WelfarePop', {
    attrs: {
      "useInfo": _vm.popData.useInfo,
      "pic": _vm.popData.pic,
      "name": _vm.popData.name,
      "jumpUrl": _vm.popData.jumpUrl,
      "isFetched": _vm.popData.isFetched
    },
    on: {
      "close": function close($event) {
        _vm.isUseInfoVisible = false;
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };